import { createAsyncThunk } from "@reduxjs/toolkit";
import * as authApi from "../../api/auth"

export const userLogin = createAsyncThunk(
    "auth/login",
    async (data) => {
        if (data !== undefined && data.data === undefined) {
            data = {
                data:
                {
                    "Type": "Azure"
                }
            };
        }
        const res = await authApi.login(data);
        //if (res.success) {
        //    store.dispatch({
        //        type: "auth/login/fulfilled",
        //        payload: res.data,
        //    })
        //}
        return res.data;
    }
);

export const getNewToken = createAsyncThunk(
    "auth/refresh-token",
    async (data) => {
        let config = {
            data
        }
        const res = await authApi.refreshToken(config);
        return res.data;
    }
);
